// Maps Contentful link objects to a flat structure for the DownloadLink dropdown
export function mapContentfulLinks(rawLinks) {
  if (!Array.isArray(rawLinks)) return []
  return rawLinks.map(item => ({
    key: item.internalTitle || item.id,
    label: item.displayTitle || item.buttonText || item.title,
    url: item.file?.file?.url || null,
    download: item.download?.file?.file?.url || item.file?.file?.url || null,
  }))
}
